import { HttpClient } from '@wix/http-client';
import { getAllPages } from './aiContentProviderUtils';
import { IPageDescription } from '@wix/adi-content-api';
import { type PromptsOverrideParams } from './aiContentProviderTypes';

interface AiContentProviderOptions {
  businessTypeName?: string;
  language: string;
  businessName?: string;
  description?: string;
  promptsOverride?: PromptsOverrideParams;
  metasiteInstance: string;
}

export class AiContentProvider {
  private allPagesData: IPageDescription[] = [];
  private readonly businessName: string;
  private businessTypeName: string;
  private readonly description: string;
  private readonly language: string;
  private readonly httpClient: HttpClient;
  private readonly promptsOverride: PromptsOverrideParams | undefined;
  resolveProcess!: () => void;
  processDone = new Promise<void>((resolve) => {
    this.resolveProcess = resolve;
  });

  constructor({
    businessName,
    businessTypeName,
    description,
    language,
    promptsOverride,
    metasiteInstance,
  }: AiContentProviderOptions) {
    this.businessName = businessName || '';
    this.businessTypeName = businessTypeName || '';
    this.description = description || '';
    this.language = language;
    this.promptsOverride = promptsOverride;
    this.httpClient = new HttpClient({
      headers: { Authorization: metasiteInstance },
    });
  }

  public setBusinessTypeName(businessTypeName: string) {
    this.businessTypeName = businessTypeName;
  }

  public init(appDefIds: string[] = []): void {
    getAllPages(this.httpClient, {
      name: this.businessName,
      category: this.businessTypeName,
      description: this.description,
      language: this.language,
      apps: appDefIds,
      promptsOverride: this.promptsOverride,
    }).then((pages) => {
      this.allPagesData = pages;
      this.resolveProcess();
    });
  }

  async waitForProcessToComplete(): Promise<void> {
    await this.processDone;
  }

  public async getInitialHomepageData() {
    await this.waitForProcessToComplete();
    return this.allPagesData[0] as IPageDescription;
  }

  public async initAdditionalPagesData() {
    await this.waitForProcessToComplete();
    return this.allPagesData.slice(1);
  }
}
